import notifier from './notifier.js';
import user from './user.js';
import signup from './signup.js';
import invoices from './invoices.js';
import claims from './claims.js';
import coverage from './coverage.js';
import usage from './usage.js';
import spendingAccounts from './spendingAccounts.js';
import whitelabel from './whitelabel.js';
import marketplace from './marketplace.js';
import loader from './loader.js';
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

/**
 * 
 * @param {*} history 
 * @returns 
 */
const rootReducer = (history) => combineReducers({
    router: connectRouter(history),
    notifier,
    user,
    signup,
    invoices,
    claims,
    coverage,
    usage,
    spendingAccounts,
    marketplace,
    loader,
    whitelabel
//   ... // rest of your reducers
});

export default rootReducer;